import Dialog from "components/ui/Dialog";
import Button from "components/ui/Button";
import { useTranslation } from "react-i18next";
import ErrorOutlineIcon from "../../../../images/payment_failed.svg?react";
import styles from "./PaymentFailedModal.module.scss";

interface Props {
  onClose: () => void;
}

// TODO: unite with PaymentSucceedModal
export default function PaymentFailedModal({ onClose }: Props) {
  const { t } = useTranslation();
  return (
    <Dialog
      open
      size="sm"
      hideHeader
      aria-label={t("Common.paymentResult.failedTitle")}
      onClose={onClose}
      closeOnOverlayClick={false}
    >
      <div className={styles.container}>
        <div className={styles.actions}>
          <ErrorOutlineIcon />
          <p className={styles.header}>{t("Common.paymentResult.failedTitle")}</p>
          <p>{t("Common.paymentResult.failedMessage")}</p>
          <Button variant="danger" size="large" onClick={onClose}>
            {t("Common.Close")}
          </Button>
        </div>
      </div>
    </Dialog>
  );
}
